var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#95d0dd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.color{fill:#95d0dd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "color",
    d: "M18.125 2.5C19.1602 2.5 20 3.33945 20 4.375C20 4.96484 19.7227 5.51953 19.25 5.875L10.75 12.25C10.3047 12.582 9.69531 12.582 9.25 12.25L0.75 5.875C0.277852 5.51953 0 4.96484 0 4.375C0 3.33945 0.839453 2.5 1.875 2.5H18.125ZM8.5 13.25C9.39062 13.918 10.6094 13.918 11.5 13.25L20 6.875V15C20 16.3789 18.8789 17.5 17.5 17.5H2.5C1.11914 17.5 0 16.3789 0 15V6.875L8.5 13.25Z",
    fill: "#4EEC91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1589392e4aac3e56ea9df82877b53dff.svg";
export { ForwardRef as ReactComponent };